import { render } from "./DeleteScoutReportForm.vue?vue&type=template&id=272b62c4"
import script from "./DeleteScoutReportForm.vue?vue&type=script&lang=js"
export * from "./DeleteScoutReportForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__